import JSZip from 'jszip';
import FileSaver from 'file-saver';
import {ProjectState} from '@/store/project';

export default async function downloadProjectFiles(project: ProjectState) : Promise<void> {
    const projectName = project.projectDef!.project.name;
    const zip = new JSZip();
    const folder = zip.folder(projectName)!;
    for (const file of project.files!)
        folder.file(file.name, file.content);
    const blob = await zip.generateAsync({ type: 'blob' });
    FileSaver.saveAs(blob, projectName);
}
